var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-top"},[_c('div',{staticClass:"main-title"},[_vm._v("交易中心")]),_vm._v(" "),_c('div',{staticClass:"main-map"},[_c('aMap')],1),_vm._v(" "),_c('div',{staticClass:"deal-center-info"},[_c('deal-center-info')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }